import PortalIdParser from 'PortalIdParser';
export const getCreatePaymentLink = () => `/payment-links/${PortalIdParser.get()}/create`;
export const getCreateSubscription = () => `/subscriptions/${PortalIdParser.get()}`;